import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=e4b59fd8&scoped=true"
import script from "./detailsPage.vue?vue&type=script&lang=js"
export * from "./detailsPage.vue?vue&type=script&lang=js"
import style0 from "./detailsPage.vue?vue&type=style&index=0&id=e4b59fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b59fd8",
  null
  
)

export default component.exports